module.exports = __webpack_public_path__ + "img/16d014-28.8b5499ff.png";